/**
 * Позволяет объединить содержимое нескольких функций.
 *
 * @param fnList Список функций
 * @returns Функция, которая объединяет в себе функциональность переданных функций
 *
 * @example
 * ```typescript
 * const combinedFn = mergeFn(firstFn, secondFn, ...restFn);
 * ```
 */
export function mergeFn(...fnList) {
    return (...args) => {
        for (const fn of fnList) {
            fn(...args);
        }
    };
}
